import AcceptableResourceMimeTypes from '../models/AcceptableResourceMimeTypes';

const replaceType = (type: AcceptableResourceMimeTypes, skip: boolean): string =>
  skip ? type : type.replace(AcceptableResourceMimeTypes.Txt, 'text/plain;charset=utf8');

export default replaceType;
